import { render } from "./CertificateType.vue?vue&type=template&id=789a1210&scoped=true"
import script from "./CertificateType.vue?vue&type=script&lang=js"
export * from "./CertificateType.vue?vue&type=script&lang=js"

import "./CertificateType.vue?vue&type=style&index=0&id=789a1210&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789a1210"]])

export default __exports__